/**
 * Copyright (c) HashiCorp, Inc.
 */

import type { TOC } from '@ember/component/template-only';
import { and } from 'ember-truth-helpers';
import { HdsIcon } from '@hashicorp/design-system-components/components';

import './cluster-path.scss';

export interface MetadataClusterPathSignature {
  Args: {
    clusterId?: string;
    partition?: string;
    namespace?: string;
  };
  Element: HTMLDivElement;
}

const MetadataClusterPath: TOC<MetadataClusterPathSignature> = <template>
  {{#if (and (and @clusterId @partition) @namespace)}}
    <div class="cut-service-cluster-path" data-test-service-cluster-path>
      <span class="hds-link-inline__icon hds-link-inline__icon--leading">
        <HdsIcon @name="server-cluster" @size="16" @stretched={{true}} />
      </span>
      {{@clusterId}}

      <span
        class="hds-link-inline__icon hds-link-inline__icon--leading cluster-path-separator"
      >
        <HdsIcon @name="chevron-right" @size="16" @stretched={{true}} />
      </span>

      <span class="hds-link-inline__icon hds-link-inline__icon--leading">
        <HdsIcon @name="users" @size="16" @stretched={{true}} />
      </span>
      {{@partition}}

      <span
        class="hds-link-inline__icon hds-link-inline__icon--leading cluster-path-separator"
      >
        <HdsIcon @name="chevron-right" @size="16" @stretched={{true}} />
      </span>

      <span class="hds-link-inline__icon hds-link-inline__icon--leading">
        <HdsIcon @name="folder-users" @size="16" @stretched={{true}} />
      </span>
      {{@namespace}}
    </div>
  {{/if}}
</template>;

export default MetadataClusterPath;
